import React, { FC } from "react";

import styles from "./QuestionHeader.module.scss";

type Props = {
  title: string;
  note: string;
};

const QuestionHeader: FC<Props> = ({ title, note }) => {
  return (
    <div className={styles.question}>
      <p className={styles.title}>{title}</p>
      <p className={styles.note}>{note}</p>
    </div>
  );
};

export default QuestionHeader;
